export default __webpack_public_path__ + "static/media/79.4f5921b3.jpg";